import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "../firebase";
import Navbar from '../components/Navbar';


function parseQuizJson(response) {
  // Try to extract the JSON array from GPT's response
  try {
    const match = response.match(/\[.*\]/s);
    if (match) return JSON.parse(match[0]);
    return [];
  } catch {
    return [];
  }
}

function BookQuizPage() {
  const { bookname } = useParams();
  const [quiz, setQuiz] = useState([]);
  const [loading, setLoading] = useState(true);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] = useState(0);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      setQuiz([]);
      setLoading(false);
      return;
    }
    fetch("https://api-jrox57cr4q-uc.a.run.app/read-book", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        uid: user.uid,
        bookname: decodeURIComponent(bookname),
        action: "quiz"
      }),
    })
      .then(res => res.json())
      .then(data => {
        const parsed = parseQuizJson(data.answer || "");
        setQuiz(parsed);
        setLoading(false);
      });
  }, [bookname]);

  // Record student's answer
  const selectAnswer = (qIdx, aIdx) => {
    setAnswers({ ...answers, [qIdx]: aIdx });
  };

  // Submit and score
  const handleSubmit = () => {
    let correct = 0;
    quiz.forEach((q, i) => {
      if (answers[i] === q.answer) correct++;
    });
    setScore(correct);
    setSubmitted(true);
  };

  // Motivational feedback
  const getMessage = (score) => {
    if (score === 5) return "🌟 Excellent! You're a quiz champion!";
    if (score >= 3) return "👏 Good job! Keep practicing to get even better.";
    return "👍 Don't worry! Keep learning, you'll improve!";
  };

  if (loading) return <div className="p-8 text-xl">Loading quiz...</div>;
  if (!quiz.length) return <div className="p-8 text-xl text-red-600">Quiz not available.</div>;

  return (
  <>
    <Navbar />
    <div className="min-h-screen flex flex-col items-center bg-green-50">
      <div className="max-w-xl w-full bg-white p-8 mt-16 rounded-lg shadow-xl">
        <h1 className="text-2xl font-bold mb-4 text-green-800">📝 Book Quiz</h1>
        {!submitted ? (
          <form
            onSubmit={e => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            {quiz.map((q, i) => (
              <div key={i} className="mb-6">
                <div className="font-semibold mb-2">
                  {i + 1}. {q.question}
                </div>
                <div className="flex flex-col gap-2">
                  {q.choices.map((choice, j) => (
                    <label key={j} className="flex items-center gap-2">
                      <input
                        type="radio"
                        name={`q${i}`}
                        value={j}
                        checked={answers[i] === j}
                        onChange={() => selectAnswer(i, j)}
                        required
                      />
                      <span>{choice}</span>
                    </label>
                  ))}
                </div>
              </div>
            ))}
            <button
              type="submit"
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded font-bold mt-4"
            >
              Submit Answers
            </button>
          </form>
        ) : (
          <div>
            <div className="text-xl font-bold mb-2">Your Score: {score} / {quiz.length}</div>
            <div className="mb-4 text-lg">{getMessage(score)}</div>
            {quiz.map((q, i) => (
              <div key={i} className="mb-5">
                <div className="font-semibold">{i + 1}. {q.question}</div>
                <div>
                  <strong>Your answer: </strong>
                  {q.choices[answers[i]] || <span className="text-gray-500">No answer</span>}
                  {answers[i] === q.answer
                    ? <span className="text-green-600 font-bold ml-2">✔️ Correct</span>
                    : <span className="text-red-600 font-bold ml-2">❌ Wrong</span>}
                </div>
                <div>
                  <strong>Correct answer: </strong>
                  {q.choices[q.answer]}
                </div>
              </div>
            ))}
            <button
              onClick={() => {
                setAnswers({});
                setSubmitted(false);
                setScore(0);
              }}
              className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded font-semibold mt-4"
            >
              Try Again
            </button>
          </div>
        )}
      </div>
    </div>
    </>
  );
}

export default BookQuizPage;
